import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addCancellationPolicy = (policyData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_CANCELLATION_POLICY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(`${BASE_URL}/policy/add`, policyData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CANCELLATION_POLICY_SUCCESS", payload: data });
        toast.success("Cancellation policy added successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_CANCELLATION_POLICY_FAILED", payload: data });
        toast.error("Failed to add cancellation policy");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_CANCELLATION_POLICY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error adding cancellation policy");
      console.error("Error in addCancellationPolicy:", error);
      return error?.response?.data || {};
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listCancellationPolicies = (filterData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_CANCELLATION_POLICIES_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(`${BASE_URL}/policy/list`, filterData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_CANCELLATION_POLICIES_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_CANCELLATION_POLICIES_FAILED", payload: data });
        toast.error("Failed to fetch cancellation policies");
      }
    } catch (error) {
      dispatch({
        type: "LIST_CANCELLATION_POLICIES_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error fetching cancellation policies");
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCancellationPolicy = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_CANCELLATION_POLICY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(`${BASE_URL}/policy/view/${id}`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_CANCELLATION_POLICY_SUCCESS", payload: data.data });
      } else {
        dispatch({ type: "VIEW_CANCELLATION_POLICY_FAILED", payload: data });
        toast.error("Failed to fetch cancellation policy details");
      }
    } catch (error) {
      dispatch({
        type: "VIEW_CANCELLATION_POLICY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error fetching cancellation policy details");
      console.error("Error in viewCancellationPolicy:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateCancellationPolicy = (updateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_CANCELLATION_POLICY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(`${BASE_URL}/policy/update`, updateData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_CANCELLATION_POLICY_SUCCESS", payload: data });
        dispatch(viewCancellationPolicy(updateData.id));
      } else {
        dispatch({ type: "UPDATE_CANCELLATION_POLICY_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_CANCELLATION_POLICY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error updating cancellation policy");
      console.error("Error updating cancellation policy:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeCancellationPolicy = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_CANCELLATION_POLICY_REQUEST" });

      const { data } = await axios.delete(`${BASE_URL}/policy/remove/${id}`);

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_CANCELLATION_POLICY_SUCCESS", payload: id });
        toast.success("Cancellation policy removed successfully!");
      } else {
        dispatch({ type: "REMOVE_CANCELLATION_POLICY_FAILED", payload: data });
        toast.error("Failed to remove cancellation policy");
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_CANCELLATION_POLICY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error removing cancellation policy");
      console.error("Error removing cancellation policy:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
